import makeStyles from "@material-ui/core/styles/makeStyles";
import "@fontsource/montserrat";

const useStyles = makeStyles((theme) => ({
  headingOne: {
    fontSize: "28px",
    fontWeight: 600,
    fontFamily: "Montserrat",
    color: "#3e4a59",
    [theme.breakpoints.down('md')]:{
      fontSize: '20px !important'
    }
  },
  headingTwo: {
    color: "rgba(86, 58, 150, 1)",
    fontSize: "40px",
    fontWeight: "600",
    fontFamily: "Montserrat",
    [theme.breakpoints.down('md')]:{
      fontSize: '24px !important'
    }
  },
  upperDisplay: {
    width: "86%",
    marginTop: "25px",
    padding: "25px",
    background:
      "linear-gradient(90deg, rgba(247,243,255,1) 0%, rgba(222, 212, 245,0.8130602582830007) 100%)",
  },
  headingthreeone: {
    fontSize: "14px",
    color: "#6f59a6",
    fontWeight: 600,
    fontFamily: "Montserrat",
  },
  headingthreetwo: {
    fontSize: "16px",
    fontWeight: "bold",
    fontFamily: "Montserrat",
    color: "#838186 !important",
  },
  showInMiddle: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  filterContainer: {
    padding: "50px 7% 0 7%",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down('md')]:{
      flexDirection: 'column'
    }
  },
  filterBy: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "rgba(0,0,0,0.4)",
    textAlign: "left",
    width: "100px",
    [theme.breakpoints.down('md')]: {
      fontSize: '16px !important'
    }
  },
  goButton: 
    {
      marginLeft: "10px",
      fontFamily: "Montserrat",
      color: "#fff",
      fontSize: "16px",
      backgroundColor: "#3ac2d7",
      [theme.breakpoints.down('md')]:{
        width: '100%'
      }
    },
  filterContainer2: {
    padding: "10px",
    display: "flex",
  },
  select: {
    fontSize: "16px",
    width: "100%",
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  selectContainer: {
    display: "flex",
    justifyContent: "right",
    [theme.breakpoints.down("md")]: {
      marginBottom: "10px",
    },
  },
  cardroot: {
    paddingTop: "30px",
    // background:
    // "linear-gradient(256deg, rgba(244,240,255,1) 0%, rgba(211,191,255,0.55) 100%)",
    background: "linear-gradient(77deg, #d9c5e789 0%, #f4f4f4 74%)",
  },
  cardImage: {
    height: "120px",
    width: "120px",
    objectFit: "cover",
    borderRadius: "5px",
    boxShadow: "3px 4px 13px -4px rgba(0,0,0,0.75)",
    objectFit: "contain",
  },
  cardText1: {
    paddingTop: "30px",
    fontSize: "18px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
    opacity: 0.9,
  },
  cardText3: {
    paddingTop: "14px",
    fontSize: "16px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
    opacity: 0.9,
  },
  cardText2: {
    fontSize: "26px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
  },
  circularDisplay: {
    height: "50px",
    width: "50px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background:
      "linear-gradient(45deg, rgba(83,255,250,1) 0%, rgba(118,95,170,1) 100%)",
    color: "#fff",
    fontWeight: "bold",
  },
  viewProfileButton: {
    transition: "0.5s",
    "&:hover": {
      transform: "translateY(-10px)",
    },
  },
  rightRotated: { transform: "rotate(-90deg)" },
  upperDisplayImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      marginBottom: "30px",
    },
  },
  mobileMarginForUpperDisplayGrids: {
    [theme.breakpoints.down("md")]: {
      marginBottom: "30px",
    },
  },
  checkboxRoot: {
    color: "#3AC2D7 !important",
    '&:hover': {
      backgroundColor: 'none'
    }
  },
  flex: {
    display: "flex",
    alignItem: "center",
  },
  sendRequestButton: {
    height: "80px !important",
    maxWidth: "none",
  },
  informationName: {
    "&:before": {
      content: ":",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 200,
    },
    textAlign: "left",
    fontSize: "14px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#3e4a59",
    position: "relative",
  },
  informationTitle:{
    textAlign: "left",
    fontSize: "14px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
    opacity: 0.9,
  },
  root: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: '10px',
    maxWidth: 'none'
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  },
  cursorPointer: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  tooltip: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: '10px',
    maxWidth: 'none'
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  },
}));

export default useStyles;
